"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableNames;
(function (TableNames) {
    TableNames["account_invites"] = "account_invites";
    TableNames["activities"] = "activities";
    TableNames["activity_progress"] = "activity_progress";
    TableNames["audit_log"] = "audit_log";
    TableNames["categories"] = "categories";
    TableNames["certifications"] = "certifications";
    TableNames["companies"] = "companies";
    TableNames["companies_sso"] = "companies_sso";
    TableNames["compliance"] = "compliance";
    TableNames["coupons"] = "coupons";
    TableNames["courses"] = "courses";
    TableNames["departments"] = "departments";
    TableNames["email_templates"] = "email_templates";
    TableNames["event_materials"] = "event_materials";
    TableNames["eventbrite_test"] = "eventbrite_test";
    TableNames["eventbrite_test_attendees"] = "eventbrite_test_attendees";
    TableNames["flat_admin_reviews"] = "flat_admin_reviews";
    TableNames["flat_bundles"] = "flat_bundles";
    TableNames["flat_certs"] = "flat_certs";
    TableNames["flat_compliance"] = "flat_compliance";
    TableNames["flat_delivery_method"] = "flat_delivery_method";
    TableNames["flat_department_tracks"] = "flat_department_tracks";
    TableNames["flat_event_attendees"] = "flat_event_attendees";
    TableNames["flat_events"] = "flat_events";
    TableNames["flat_modules"] = "flat_modules";
    TableNames["flat_owners"] = "flat_owners";
    TableNames["flat_payee"] = "flat_payee";
    TableNames["flat_progress"] = "flat_progress";
    TableNames["flat_reviews"] = "flat_reviews";
    TableNames["flat_team_tracks"] = "flat_team_tracks";
    TableNames["flat_user_courses"] = "flat_user_courses";
    TableNames["flat_user_tracks"] = "flat_user_tracks";
    TableNames["flat_vendors"] = "flat_vendors";
    TableNames["integrations"] = "integrations";
    TableNames["lambda_trigger_example"] = "lambda_trigger_example";
    TableNames["level"] = "level";
    TableNames["location"] = "location";
    TableNames["logstash_input_dynamodb_cptr"] = "logstash_input_dynamodb_cptr";
    TableNames["notifications"] = "notifications";
    TableNames["onboard_requests"] = "onboard_requests";
    TableNames["payee_tracking"] = "payee_tracking";
    TableNames["practice_areas"] = "practice_areas";
    TableNames["profiles"] = "profiles";
    TableNames["prolaera"] = "prolaera";
    TableNames["public_courses"] = "public_courses";
    TableNames["purchases"] = "purchases";
    TableNames["questions"] = "questions";
    TableNames["Queue"] = "Queue";
    TableNames["regulators"] = "regulators";
    TableNames["review_forms"] = "review_forms";
    TableNames["scorm_attendees"] = "scorm_attendees";
    TableNames["scorm_progress"] = "scorm_progress";
    TableNames["sent_invitations"] = "sent_invitations";
    TableNames["sponsors"] = "sponsors";
    TableNames["teams"] = "teams";
    TableNames["tracks"] = "tracks";
    TableNames["users"] = "users";
    TableNames["wait_list_attendees"] = "wait_list_attendees";
})(TableNames = exports.TableNames || (exports.TableNames = {}));
//# sourceMappingURL=tableNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/types/dist/enums/tableNames.js
// module id = 884
// module chunks = 0